/*
 * Copyright 2026 Sony Corporation
 */

import { AppHeader } from './AppHeader';
import { useWorldName } from '../hooks/use-world';

export interface WorldHeaderProps {
  worldId: string;
  /** Passed by a page that has already loaded the world, which then costs no request. */
  name?: string;
  children?: React.ReactNode;
}

/**
 * The header for every page inside a world.
 *
 * Scene, Devices and Deploy are three views of one world, and the bar across
 * the top is what says so. Having each page decide its own title is how the
 * Scene page ended up showing a UUID and then nothing at all.
 */
export const WorldHeader = ({ worldId, name, children }: WorldHeaderProps) => (
  <AppHeader title={useWorldName(worldId, name)}>{children}</AppHeader>
);
